import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const getGroup = (createdAt) => {
  const date = dayjs(createdAt);
  if (date.isSame(dayjs(), 'day')) return 'TODAY';
  if (date.isSame(dayjs().subtract(1, 'day'), 'day')) return 'YESTERDAY';
  return 'EARLIER';
};

const formatPickup = (pickUpDate, timezone) => {
  if (!pickUpDate) return null;

  const date = new Date(pickUpDate);
  if (Number.isNaN(date.getTime())) return null;

  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    ...(timezone && { timeZone: timezone }),
  });
};

const getRide = (notification) => {
  if (notification.entityType !== 'RIDE') return null;
  return notification.metadata?.ride ?? null;
};

const buildRideMeta = (ride) => {
  if (!ride) return null;

  const parts = [];
  if (ride.seqId) parts.push(`Ride ID: ${ride.seqId}`);

  const pickup = formatPickup(ride.pickUpDate, ride.timezone);
  if (pickup) parts.push(`Pickup: ${pickup}`);

  return parts.length ? parts.join(' • ') : null;
};

export const mapNotificationToAlert = (notification) => {
  const ride = getRide(notification);

  return {
    id: notification.id,
    group: getGroup(notification.createdAt),
    title: notification.title,
    description: notification.body,
    meta: buildRideMeta(ride),
    timestamp: dayjs(notification.createdAt).fromNow(),
    createdAt: notification.createdAt,
    unread: notification.status === 'UNREAD',
    type: notification.actionBy?.toLowerCase(),
    pickupAddress: ride?.pickupAddressDetails?.formattedAddress ?? null,
    dropoffAddress: ride?.destinationAddress?.formattedAddress ?? null,
    status: ride?.status ?? null,
    tab: 'all',
    entityType: notification.entityType,
    entityId: notification.entityId,
    organizationId: notification.organizationId,
  };
};
